import React from 'react';

import { List, Modal } from 'antd';

import EmptyState from '@components/Gui/EmptyState';
import { NwButton } from '@components/Gui/NwButton';
import NwIcon from '@components/Gui/NwIcon';

import { PublishedBookContainer } from './PlaylistPublishedWebsitesUI';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const { confirm } = Modal;

const PlaylistPublishedWebsitesList = ({
    emptyMessage = 'No websites',
    linkedSections = [],
    loading = false,
    onUnlink,
    showActions = true,
}) => {
    const handleConfirmUnlink = (item) => {
        confirm({
            title: <div>Remove website publication?</div>,
            content: (
                <div>
                    <p>
                        Website: <strong>{item.websiteName}</strong>
                    </p>
                    <p>
                        Division: <strong>{item.path}</strong>
                    </p>
                </div>
            ),
            onOk() {
                onUnlink(item);
            },
            onCancel() {},
        });
    };

    if (!linkedSections.length) {
        return <EmptyState message={emptyMessage} />;
    }

    return (
        <List
            itemLayout="horizontal"
            loading={loading}
            dataSource={linkedSections}
            renderItem={(item) => (
                <List.Item
                    key={`${item.playlistID}-${item.websiteCode}-${item.divisionCode}`}
                    actions={
                        showActions && onUnlink
                            ? [
                                  <NwButton
                                      iconOnly
                                      ghost
                                      disabled={loading}
                                      loading={loading}
                                      icon={byPrefixAndName.fasl['trash-alt']}
                                      onClick={() => handleConfirmUnlink(item)}
                                  />,
                              ]
                            : []
                    }
                >
                    <List.Item.Meta
                        description={
                            <PublishedBookContainer>
                                <div className="published-book-icon">
                                    <NwIcon icon={byPrefixAndName.fasl['globe']} />
                                </div>
                                <div className="published-book-info">
                                    <p>
                                        WEBSITE: <strong>{item.websiteName}</strong>
                                    </p>
                                    <p>
                                        DIVISION: <strong>{item.path}</strong>
                                    </p>
                                    <p>as {item.role}</p>
                                </div>
                            </PublishedBookContainer>
                        }
                    />
                </List.Item>
            )}
        />
    );
};

export default PlaylistPublishedWebsitesList;
